// Page: Templates

import TemplateSearch from '../modules/templates/templateSearch'

const body = document.querySelector('body')
const isTemplatesPage = body.classList.contains('page--templates')

if (isTemplatesPage) {
  new TemplateSearch()
}
